import request from '@/utils/request'

/**
 * 进入客服会话（自动分配客服）
 */
export function enterService(userId) {
  return request({
    url: '/websocket/chat/enterService',
    method: 'get',
    params: { userId }
  })
}

/**
 * 获取历史聊天记录
 */
export function getHistoryMessages(conversationKey, pageNum = 1, pageSize = 20) {
  return request({
    url: '/websocket/chat/history',
    method: 'get',
    params: { conversationKey, pageNum, pageSize }
  })
}

/**
 * 标记会话已读
 */
export function markConversationRead(conversationKey, userId, userType) {
  return request({
    url: '/websocket/chat/markRead',
    method: 'post',
    params: { conversationKey, userId, userType }
  })
}

/**
 * 获取未读消息总数
 */
export function getUnreadCount(userId, userType) {
  return request({
    url: '/websocket/chat/unreadCount',
    method: 'get',
    params: { userId, userType }
  })
}

/**
 * 获取会话列表（代理商一对多）
 * 返回当前 userId 名下所有会话：customerId/customerName/lastMessage/lastTime/unreadCount/conversationKey 等
 */
export function getConversationList(userId, userType) {
  return request({
    url: '/websocket/chat/conversation/list',
    method: 'get',
    params: { userId, userType }
  })
}

/**
 * 聊天文件上传（图片/视频）
 */
export function uploadChatFile(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/websocket/chat/upload',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

/**
 * 转内勤客服（代理商端调用）
 */
export function transferToAdmin(userId) {
  return request({
    url: '/websocket/chat/transferToAdmin',
    method: 'get',
    params: { userId }
  })
}

/**
 * 结束当前对话（内勤端调用）
 */
export function endSession(userId) {
  return request({
    url: '/websocket/chat/endSession',
    method: 'post',
    params: { userId }
  })
}
